<template>
    <div>
    <!--PAGE HEADER-->
        <app-page-header :areaTitle="departmentName" :menuItem="menuItem" />
       
    <!--SHOW MODE-->
        <div v-if="showMode" class="row text-left">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <p class="small">Total users: {{totalUsers}}</p>
                        <hr>
                        <p class="lead text-info">Users list:</p>
                        <table class="table table-responsive table-striped">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Registered on</th>
                                    <th class="text-center">Role</th>
                                    <th class="text-center">User status</th>
                                    <th class="text-center">Edit</th>
                                    <th class="text-center">Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in allUsers" :key="user.id">
                                    <td>ID: {{ user.id }}</td>
                                    <td class="lead text-center">{{ user.username }}</td>
                                    <td class="text-center">{{ user.registeruserdate }}</td>
                                    <td class="text-center">{{ user.userrole }}</td>
                                    <td class="text-center">{{ user.userstatus == 1 ? 'ON' : 'OFF' }}</td>
                                    <td><button class="btn btn-secondary" @click="editUser(user.id)"><i class="fas fa-edit"></i></button></td>                                
                                    <td><button class="btn btn-secondary" @click="deleteUser(user.id)"><i class="fas fa-trash-alt"></i></button></td>
                                </tr>                                
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    <!--EDIT MODE -->
        <div v-if="editMode" class="row text-left">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <p class="lead text-info">Edit user id: {{editedUser.id}}</p>
                        <div class="text-right">
                            <a href="#" @click="showMode=true, editMode=false"><i class="fas fa-backward"></i> Show all users</a>
                        </div>
                        <form @submit.prevent="updateUser">
                            <div class="row">
                                <div class="col-md-6">
                                    <input class="form-control my-2" type="text" v-model="editedUser.username">
                                    <input class="form-control" type="email" v-model="editedUser.useremail">
                                </div>
                                <div class="col-md-6">
                                    <select class="form-control my-2"
                                            :class="editedUser.userrole==='boss' ? 'text-danger' : 'text-success'"
                                            id="user-role"
                                            v-model="editedUser.userrole">
                                        <option value="user" class="text-danger">User</option>
                                        <option value="admin" class="text-success">Admin</option>                                        
                                        <option value="boss" class="text-success">Boss</option>                                        
                                    </select>

                                        <select class="form-control my-2"
                                            :class="editedUser.userrole== 0 ? 'text-danger' : 'text-success'"
                                            id="user-status"
                                            v-model="editedUser.userstatus">
                                        <option value="0" class="text-danger">User status - Off</option>
                                        <option value="1" class="text-success">User status - On</option>                                        
                                    </select>
                                </div>
                            </div>
                            <input class="btn btn-block mt-2 p-3" type="submit" value="Update">                            
                        </form>
                    </div>
                </div>
            </div>
        </div>

    <!--CONFIRMATION MESSAGES -->
        <app-confirmation @showDialogue="closeDialogue" :successMessage="successMessage" :errorMessage="errorMessage" v-if="showingMessageModal" /> 
    </div>
</template>

<script>
import axios from 'axios'
import pageHeader from '@/components/Helpers/PageHeader.vue'
import comfDialog from '@/components/Helpers/ConfirmationDialogue.vue'

    export default {
            props: ['userrole'],
            components: { appConfirmation : comfDialog, appPageHeader: pageHeader },
            data(){
                    return {
                        apiURL: process.env.APP_API,
                        departmentName: "User Managing Area",
                        menuItem: 'Users',
                        
                        allUsers: [],
                        totalUsers: 0,
                    
                        editedUser: {
                            id: null,
                            username: '',
                            useremail: '',                    
                            userrole: '',
                            userstatus: ''
                        },
                        errorMessage: '',
                        successMessage: '',

                        showMode: true,
                        editMode: false,
                        showingMessageModal: false
                    }
                },
            mounted() {
                    this.getAllUsers()
                },
            methods: {
                    closeDialogue(status){
                            this.showingMessageModal = status
                        },
                    getAllUsers() {
                       axios.get(this.apiURL + '?action=readallusers')
                            .then((res) => {
                                if(res.data.error){
                                    app.errorMessage = res.data.message
                                } else {
                                    this.allUsers = res.data.users
                                    this.totalUsers = this.allUsers.length
                                }
                            })
                        },
                    editUser(id){
                            this.showMode = false
                            this.editMode = true

               
                           axios.get(this.apiURL + '?action=readcurrentuser', {
                                    params: {
                                        id: id
                                    }
                                })
                                .then((res) => {
                                    if(res.data.error){
                                        this.errorMessage = res.data
                                        console.log(res.data)

                                    } else {
                                        // this.currentUser = res.data.currentUser
                                        this.editedUser.id = res.data.currentUser[0].id                                
                                        this.editedUser.username = res.data.currentUser[0].username
                                        this.editedUser.useremail = res.data.currentUser[0].useremail
                                        this.editedUser.userrole = res.data.currentUser[0].userrole
                                        this.editedUser.userstatus = res.data.currentUser[0].userstatus
                                    }
                                })
                        
                        },
                    updateUser(id){

                            const formData = new FormData()

                            formData.append('id', this.editedUser.id)
                            formData.append('username', this.editedUser.username)
                            formData.append('useremail', this.editedUser.useremail)
                            formData.append('userrole', this.editedUser.userrole)                
                            formData.append('userstatus', this.editedUser.userstatus)

                            // for(var item of formData){
                            //        console.log('На отправку!', item)
                            //    }  

                           axios.post(this.apiURL + '?action=updateuser', formData)
                                .then((res) => {
                                    if(res.data.error){
                                        console.log(res.data)
                                        this.errorMessage = res.data.message
                                        this.showingMessageModal = true                                
                                    } else {
                                        console.log(res.data)
                                        this.successMessage = res.data.message
                                        this.showingMessageModal = true
                                            setTimeout(()=> {
                                                this.showingMessageModal = false
                                            }, 2000)
                                            setTimeout(()=>{
                                                this.getAllUsers()
                                                this.editMode = false
                                                this.showMode = true
                                                this.successMessage = ''
                                                this.errorMessage = ''
                                            }, 3000)                                                      
                                        }
                                    })
                                },
                    deleteUser(id){
                        var del = confirm('Are you serious?')
                            if(del){
                                const formData = new FormData()
                                formData.append('id', id)

                           axios.post(this.apiURL + '?action=deleteuser', formData)
                                .then((res) => {
                                    if(res.data.error){
                                        this.errorMessage = res.data.message
                                        this.showingMessageModal = true
                                    } else {
                                        this.successMessage = res.data.message
                                        this.showingMessageModal = true
                                        this.getAllUsers()                                
                                            setTimeout(()=> {
                                                this.editMode = false
                                                this.showMode = true
                                                this.showingMessageModal = false
                                            }, 2000)
                                    }
                                })
                            }
                        }
                }
        }
</script>

<style>
    /* MODAL MESSAGE */    
        .modalMessageContent {
            min-height: 100px;
            padding: 10px;
        }
        .modalMessageContainer {
            width: 500px;
            background: #ffffff;
            margin: auto;
            margin-top: 150px;
            border-radius: 8px;
        }
        .modalMessageHeading {
            padding: 9px;
            color: #ffffff;
        }
        .modMessageBackground {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom:0;
            background: rgba(0,0,0,0.4); z-index:99;
        }
</style>


// WEBPACK FOOTER //
// src/components/Users/Users.vue